module.exports = __webpack_public_path__ + "media/images/icons/star-a4292c74cb1ebf6f9467fd566e812907.svg";